// @ts-ignore
import styles from './PlanPerMonth.module.scss';
import HealthPlanBox from '../HealthPlanBox/HealthPlanBox';
import Collapse from '../Collapse/Collapse';
import HealthPlanAddOption from '../HealthPlanAddOption/HealthPlanAddOption';
import React from 'react';
import { HealthPlanTimelineGroup } from '../../../Models/HealthPlan/HealthPlanTimelineGroup';
import { useAppContext } from '../../../Services/AppContext';

interface PlanPerMonth {
	data: HealthPlanTimelineGroup[];
	patientId?: string;
	workplaceId?: string;
	reloadData?: any;
}

export default function PlanPerMonth(props: PlanPerMonth) {
	const { data, patientId, workplaceId, reloadData } = props;

	return (
		<div className={styles.wrapper}>
			{data.map((column, index) => (
				<React.Fragment key={index}>
					<Collapse
						title={column.title}
						contentPadding
						defaultOpen={!column.collapseOpened}
					>
						<div className='row'>
							{column.children.map((item, index) => (
								<div
									key={index}
									className='col-lg-3 col-md-4 col-6'
									style={{ marginBottom: '15px' }}
								>
									<HealthPlanBox
										item={item}
										patientId={patientId}
										workplaceId={workplaceId}
										reloadData={reloadData}
									/>
								</div>
							))}
							<div className='col-lg-3 col-md-4 col-6'>
								<HealthPlanAddOption
									month={index + 1}
									reloadData={reloadData}
								/>
							</div>
						</div>
					</Collapse>
				</React.Fragment>
			))}
		</div>
	);
}
